<template>
  <div>
    <van-tabbar
      route
      v-model="active"
      active-color="#557ff9"
      inactive-color="#8b8b8d"
      class="main-tab"
    >
      <van-tabbar-item v-for="(item,index) in tabbars" :key="index" replace :to="item.path">
        <span>{{item.text}}</span>
        <template #icon="props">
          <img :src="props.active ? item.active : item.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { Tabbar as VanTabbar, TabbarItem as VanTabbarItem } from 'vant';
export default {
  name: 'Tab',
  components: {
    VanTabbar,
    VanTabbarItem
  },
  props: {
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      active: 0,
      tabbar: ['index', 'examlist', 'recommend', 'user', ],
      tabbars: [
        {
          text: '首页',
          name: 'index',
          path: '/',
          active: require('@/assets/images/nav_1_hover.png'),
          inactive: require('@/assets/images/nav_1.png')
        },
        {
          text: '考试历',
          name: 'examlist',
          path: '/examlist',
          active: require('@/assets/images/nav_2_hover.png'),
          inactive: require('@/assets/images/nav_2.png')
        },
        {
          text: '推荐',
          name: 'recommend',
          path: '/recommend',
          active: require('@/assets/images/nav_3_hover.png'),
          inactive: require('@/assets/images/nav_3.png')
        },
        {
          text: '我的',
          name: 'user',
          path: '/user',
          active: require('@/assets/images/nav_4_hover.png'),
          inactive: require('@/assets/images/nav_4.png')
        },
      ]
    };
  },
  created() {
    this.active = this.currentIndex;
  },
  methods: {
    tabbarActive(name) {
      var index = this.tabbars.map(item => item.name).indexOf(name);
      if (index != -1) {
        this.active = index;
      }
    }
  },
  watch: {
    $route(to) {
      // 对路由变化作出响应
      this.tabbarActive(to.name);
    },
  }
};
</script>



// WEBPACK FOOTER //
// tabbar.vue?3a561a1e